import React from 'react';
import { TextField } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';
import { resolveValidationRules } from '../../../../../../utilities/validationRuleHelper';

const SummaryFieldWrite = ({ summaryValue, onChange, validationEntity }) => {
  const { t: translator } = useTranslation();
  let { maxLength } = resolveValidationRules(validationEntity);

  const onChangeLocal = (_, value) =>
    onChange(value && value.substring(0, maxLength));

  return (
    <div
      className="create-hearing-form-field"
      aria-label={translator('ariaLabel.summaryFieldWrite')}
    >
      <TextField
        label={translator('pages.createHearing.summaryLabel')}
        multiline={true}
        autoAdjustHeight={true}
        placeholder={translator('pages.createHearing.summaryPlaceholder')}
        onChange={onChangeLocal}
        styles={{ field: { minHeight: '125px', maxHeight: '500px' } }}
        value={summaryValue}
      />
      <div>
        <p className="field-limit-char-count">
          {translator('global.noOfChars')}{' '}
          {summaryValue ? summaryValue.length : 0}/{maxLength}
        </p>
      </div>
    </div>
  );
};

export { SummaryFieldWrite };
